






































import Vue from 'vue'
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { PageTitle } from '@questelservices/common-vue';
import { DxSelectBox, DxButton, DxLoadPanel } from 'devextreme-vue';
import { ClientService } from '../../service/ClientService';
import { SelectOption } from '../../models/SelectOption';
import { BatchDetailsDto } from '../../models/batch/BatchDetailsDto';
import { BatchService } from '../../service/BatchService';
import BatchList from '../../components/batch/batch-list.vue';
import dialog from 'devextreme/ui/dialog';

@Component({
  components: {
    PageTitle,
    DxSelectBox,
    BatchList,
    DxButton,
    DxLoadPanel
  }
})
export default class ClientBatches extends Vue {
  clients: Array<SelectOption> = [];
  selectedClient: Guid = '';
  batches: Array<BatchDetailsDto> = [];

  batchService: BatchService = new BatchService();

  private get routeClientId() : Guid | undefined {
    return this.$route.params['clientId'];
  }

  @Watch('routeClientId') 
  private routeClientIdChange(){
    this.setClientFromRoute();
  }

  private setClientFromRoute() {
    // If the route has a parameter for the clientId, select it
    if(this.routeClientId && this.selectedClient !== this.routeClientId) {
      this.selectedClient = this.routeClientId;
    } else if (!this.routeClientId) {
      this.selectedClient = '';
    }
  }

  mounted() {
    this.loadData();
    this.setClientFromRoute();
  }

  async loadData() {
    let clientService = new ClientService();
    let clients = await clientService.getAll();
    this.clients = clients.map(c => { return { text: c.ClientName, value: c.ClientId } });
  }

  @Watch('selectedClient')
  private async clientChange() {
    this.batches = [];
    if(this.selectedClient) {
      if(this.routeClientId !== this.selectedClient) {
        this.$router.push({ name: 'client-batches', params: { clientId: this.selectedClient } });
      }
      await this.loadBatches();
    }
  }

  private async loadBatches() {
    this.batches = await this.batchService.getClientBatches(this.selectedClient);
  }

  addingClientBatch: boolean = false;
  
  async addNewClientBatch() {
    let confirm = await dialog.confirm('Adding a new client batch will close any existing batch. Would you like to continue?', 'Confirm');
    if(confirm) {
      this.addingClientBatch = true;
      await this.batchService.addNewBatch(this.selectedClient).catch(await this.addNewClientBatchError);
      await this.loadBatches();
      this.addingClientBatch = false;
    }
  }

  async addNewClientBatchError(error: any) {
    let message = 'An error occurred adding a new client batch';
    message += error.Message ? ': ' + error.Message : '.';
    await dialog.alert(message, 'Error');
  }
}
